import React, { useEffect, useRef, useState } from 'react';
import { zegoEngine } from '../../zegoCallConfig';
import { loginToZego } from '../../components/utils/zegoLoginVC';

const VideoCall: React.FC = () => {
  const localVideoRef = useRef<HTMLDivElement>(null);
  const remoteVideoRef = useRef<HTMLDivElement>(null);

  const [isIncomingCall, setIsIncomingCall] = useState(false);
  const [isInRoom, setIsInRoom] = useState(false);
  const [hasStartedCall, setHasStartedCall] = useState(false);

  const userID = 'LMS51devv2';
  const userName = 'LMS51devv2';
  const roomID = 'LMS51devv2';
  const streamID = 'LMS4devv2';
  const zg = zegoEngine;

  let localStream: any = null;

  useEffect(() => {
    const setup = async () => {
      const result = await loginToZego(userID, userName, roomID);
      if (result === true) {
        console.log('✅ Logged in to room');
        setIsInRoom(true);
      } else {
        console.error('❌ Failed to login');
      }
    };

    setup();

    // Dengarkan stream remote masuk (anggap sebagai telepon masuk)
    zg.on('roomStreamUpdate', async (roomID, updateType, streamList) => {
      console.log(streamList);
      if (updateType === 'ADD' && streamList.length > 0) {
        console.log('📞 Incoming call detected');
        setIsIncomingCall(true);
      } else if (updateType === 'DELETE' && streamList.length > 0) {
        zg.stopPlayingStream(streamList[0].streamID);
        if (remoteVideoRef.current) remoteVideoRef.current.innerHTML = '';
      }
    });

    // Cleanup
    return () => {
      if (localStream) {
        zg.stopPublishingStream(streamID);
        zg.destroyStream(localStream);
      }
      zg.logoutRoom(roomID);
      zg.off('roomStreamUpdate');
    };
  }, []);

  const startCall = async () => {
    localStream = await zg.createZegoStream();
    if (localVideoRef.current) {
      localStream.playVideo(localVideoRef.current, { enableAutoplayDialog: true });
    }
    zg.startPublishingStream(streamID, localStream);
    setHasStartedCall(true);
  };

  // Play remote video jika tombol start ditekan
  useEffect(() => {
    if (!hasStartedCall) return;

    zg.on('roomStreamUpdate', async (roomID, updateType, streamList) => {
      if (updateType === 'ADD' && streamList.length > 0) {
        const remoteStreamID = streamList[0].streamID;
        const remoteStream = await zg.startPlayingStream(remoteStreamID);
        const remoteView = zg.createRemoteStreamView(remoteStream);
        if (remoteVideoRef.current) {
          remoteView.play(remoteVideoRef.current, { enableAutoplayDialog: true });
        }
      }
    });
  }, [hasStartedCall]);

  return (
    <div style={{ textAlign: 'center' }}>
      <h1>Zego RTC Video Call</h1>

      {!hasStartedCall && isIncomingCall && (
        <div style={{ margin: '20px' }}>
          <p>📞 Incoming Call...</p>
          <button
            onClick={startCall}
            style={{ padding: '10px 20px', fontSize: '16px', background: '#28a745', color: '#fff' }}
          >
            Start Call
          </button>
        </div>
      )}

      {/* {hasStartedCall && ( */}
        <div style={{ width: '610px', margin: '0 auto' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <h4>Local video</h4>
            <h4>Remote video</h4>
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <div
              ref={localVideoRef}
              style={{ width: '300px', height: '270px', backgroundColor: '#ccc' }}
            ></div>
            <div
              ref={remoteVideoRef}
              style={{ width: '300px', height: '270px', backgroundColor: '#ccc' }}
            ></div>
          </div>
        </div>
      {/* )} */}
    </div>
  );
};

export default VideoCall;
